import store from '@/store'
import storage from 'store'
import TimeControl from '@/utils/time-control'

/**
 * 配置
 */
export default class Config {
	
	// 当前平台
	static VUE_APP_PROJECT = 'Nageshenme'; // Nageshenme|Tutoredin

	// 获取基础地址
	static baseUrl(name) {
		let uri = null;
		if(this.VUE_APP_PROJECT === 'Tutoredin') {
			if(process.env.NODE_ENV == 'development') {
				uri = 'http://api.tutoredin.im';
			} else {
				uri = 'https://api.tutoredin.com';
			}
		} else if(this.VUE_APP_PROJECT == 'Nageshenme') {
			if(process.env.NODE_ENV == 'development') {
				uri = 'http://api.nageshenme.im';
			} else {
				uri = 'https://api.nageshenme.com';
			}
		}
		if(!!name) {
			if(name[0] != '/') {
				name = '/' + name;
			}
			uri += name;
		}
		return uri;
	}
	
	// 判断是否是Tutoredin项目
	static isTutoredin() {
		if(this.VUE_APP_PROJECT == 'Tutoredin') {
			return true;
		}
		return false;
	}

	// isNageshenme
	static isNageshenme() {
		if(this.VUE_APP_PROJECT == 'Nageshenme') {
			return true;
		}
		return false;
	}

	// 默认语言 localeLang
	static localeLang(lang) {
		if(!!!lang) {
			lang = this.website('language');
		}
		let name = null
		if(this.isTutoredin()) {
			name = !!lang && lang == 'zh-cn' ? 'zh-cn' : 'en';
		} else if(this.isNageshenme()){
			name = !!lang && lang == 'zh-cn' ? 'zh-cn' : 'ru';
		}
		return name;
	}

	// 请求数据头信息
	static headers() {
		let obj = {};
		if(this.isTutoredin()) {
			obj.accept = `application/vnd.tutoredin.v1+json`;
		} else if(this.isNageshenme()){
			obj.accept = `application/vnd.nageshenme.v1+json`;
		}
		obj.isChina = this.website('isGuessChina');

		return obj;
	}

	// 网站基本信息
	static website(name) {
		let obj = {};
		obj.title = this.VUE_APP_PROJECT;
		obj.country = 1;
		obj.area_code = "+86";
		if(this.isTutoredin()) {
			obj.title = 'Tutoredin';
			obj.beian = '京ICP备2021015873号-1';
			obj.country = 2;
			obj.area_code = "+44";
		} else if(this.isNageshenme()) {
			obj.title = 'Nageshenme';
			obj.beian = '';
			obj.country = 4;
			obj.area_code = "+7";
		}
		obj.language = navigator.language.toLowerCase();
		
		obj.isGuessChina = 0;
		if(obj.language != 'zh-cn' || !TimeControl.guessTimezone("Asia/Shanghai")) {
			obj.beian = null;
		} else {
			obj.isGuessChina = 1;
		}
		return name ? obj[name] : obj;
	}

	// 处理平台的某些默认值
	static basicInfo(userInfo) {
		let info = store.getters.userInfo;
		if(!!userInfo) {
			info = userInfo;
		}
		info.minRate = 0;
		if(info.currency_value == 1) {
			info.minRate = 125;
		} else if(info.currency_value == 2) {
			info.minRate = 16;
		} else if(info.currency_value == 4) {
			info.minRate = 1700;
		}


		return info;
	}

	// 平台支持所有时区
	static timeZoneList(zone) {
		let array = [];
		array.push({name: "Beijing", zone: "Asia/Shanghai", name2: "北京时间", name3: "北京时间", desc: "UTC+8"});
		array.push({name: "Kaliningrad", zone: "Europe/Kaliningrad", name2: "莫斯科时间", desc: "UTC+2"});
		array.push({name: "Moscow", zone: "Europe/Moscow", name2: "莫斯科时间", name3: "Московский Время, MSK", desc: "UTC+3"});
		array.push({name: "Samara", zone: "Europe/Samara", name2: "莫斯科时间", desc: "UTC+4"});
		array.push({name: "Yekaterinburg", zone: "Europe/Yekaterinburg", name2: "莫斯科时间", desc: "UTC+5"});
		array.push({name: "Omsk", zone: "Asia/Omsk", name2: "鄂木斯克", name3: "Омскское Время, OMSK", desc: "UTC+6"});
		array.push({name: "Krasnoyarsk", zone: "Asia/Krasnoyarsk", name2: "克拉斯诺亚尔斯克", name3: "Красноярское Время, KRAT", desc: "UTC+7"});
		array.push({name: "Irkutsk", zone: "Asia/Irkutsk", name2: "伊尔库茨克", name3: "Иркутское Время, IRKT", desc: "UTC+8"});
		array.push({name: "Yakutsk", zone: "Asia/Yakutsk", name2: "雅库茨克", name3: "Якутское Время, YAKT", desc: "UTC+9"});
		array.push({name: "Vladivostok", zone: "Asia/Vladivostok", name2: "符拉迪沃斯托克", name3: "Владивостокское Время, VLAT", desc: "UTC+10"});
		array.push({name: "Srednekolymsk", zone: "Asia/Magadan", name2: "马加丹", name3: "Магаданское Время, MAGT", desc: "UTC+11"});
		array.push({name: "Kamchatka", zone: "Asia/Kamchatka", name2: "", desc: "UTC+12"});

		if(!!zone) {
			let obj = {};
			array.forEach((item, index) => {
				if(item.zone == zone) {
					obj = item;
				}
			})
			return obj;
		}
		return array
	}

	// 学生第一次进入时的信息
	static studentConfigInfo() {
		var obj = {
			"goal": [
				{
					"label": "Career and business",
					"value": "1"
				},
				{
					"label": "Lessons for kids",
					"value": "2"
				},
				{
					"label": "Exams and course work",
					"value": "3"
				},
				{
					"label": "Culture, travel and hobby",
					"value": "4"
				}
			],
			"level": [
				{
					"label": "I'm just starting",
					"value": "1"
				},
				{
					"label": "I know the basics",
					"value": "2"
				},
				{
					"label": "I'm conversational",
					"value": "3"
				},
				{
					"label": "I'm fluent in most situations",
					"value": "4"
				}
			],
			"interests": [
				{
					"label": "Conversational Chinese",
					"value": "1"
				},
				{
					"label": "Chinese for traveling",
					"value": "2"
				},
				{
					"label": "For studying abroad",
					"value": "3"
				},
				{
					"label": "HSK ",
					"value": "4"
				},
				{
					"label": "Chinese for kids",
					"value": "5"
				},
				{
					"label": "Chinese literature",
					"value": "6"
				},
				{
					"label": "Intensive Chinese",
					"value": "7"
				},
				{
					"label": "Chinese for beginners",
					"value": "8"
				},
				{
					"label": "Business Chinese",
					"value": "9"
				},
				{
					"label": "Chinese for Professionals",
					"value": "10"
				}
			]
		}
		return obj;
	}
}